import { forwardRef, type Ref, type SVGProps } from "react";

function SvgAccessUnlock(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 101 68" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M38.1615 28.0305V18.9396C38.1615 12.2452 43.6852 6.81836 50.4991 6.81836C57.313 6.81836 62.8368 12.2452 62.8368 18.9396V21.8752M35.077 61.3638H65.9212C69.3281 61.3638 72.09 58.6504 72.09 55.3032V34.0911C72.09 30.7439 69.3281 28.0305 65.9212 28.0305H35.077C31.6701 28.0305 28.9082 30.7439 28.9082 34.0911V55.3032C28.9082 58.6504 31.6701 61.3638 35.077 61.3638Z"
        stroke="url(#paint0_linear_117_4063)"
        strokeWidth="5.68182"
      />
      <path
        d="M24.3485 1.69021C24.3485 1.38425 24.1005 1.13623 23.7946 1.13623C23.4886 1.13623 23.2406 1.38425 23.2406 1.69021C23.2406 3.99494 22.7319 5.52795 21.7659 6.49395C20.7999 7.45995 19.2669 7.96862 16.9622 7.96862C16.6562 7.96862 16.4082 8.21664 16.4082 8.52259C16.4082 8.82855 16.6562 9.07657 16.9622 9.07657C19.2669 9.07657 20.7999 9.58524 21.7659 10.5512C22.7319 11.5172 23.2406 13.0502 23.2406 15.355C23.2406 15.6609 23.4886 15.909 23.7946 15.909C24.1005 15.909 24.3485 15.6609 24.3485 15.355C24.3485 13.0502 24.8572 11.5172 25.8232 10.5512C26.7892 9.58524 28.3222 9.07657 30.627 9.07657C30.9329 9.07657 31.1809 8.82855 31.1809 8.52259C31.1809 8.21664 30.9329 7.96862 30.627 7.96862C28.3222 7.96862 26.7892 7.45995 25.8232 6.49395C24.8572 5.52795 24.3485 3.99494 24.3485 1.69021Z"
        fill="#0D2B57"
      />
      <path
        d="M50.5 39.2046L50.5 47.1591"
        stroke="#0C1C43"
        strokeWidth="0.568182"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_117_4063"
          x1="50.4991"
          y1="6.81836"
          x2="50.4991"
          y2="61.3638"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#DBD8FE" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgAccessUnlock);
export default ForwardRef;
